import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { DELETE, EDIT, REVIEW } from "const"
import { hasProjectAccess } from "client/utils"
import {
    PRM_CC_REVIEW,
    StoreType,
    setCcReviewReviewPopupMenuShow,
    setCcReviewReviewShowConfirmDelete,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import { OpenAnswer, OpenEdit } from "./open"

const Menu = () => {
    const baseRoute = useSelector((state: StoreType) => state.ccReviewDocument.baseRoute)
    const activeFile = useSelector((state: StoreType) => state.ccReviewDocument.activeFile)
    const activeVersion = useSelector((state: StoreType) => state.ccReviewDocument.activeVersion)

    const revisionActiveList = useSelector((state: StoreType) => state.ccReviewReview.revisionActiveList)
    const activeItem = useSelector((state: StoreType) => state.ccReviewReview.active)
    const menuShow = useSelector((state: StoreType) => state.ccReviewReview.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.ccReviewReview.menuTarget)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [menuItems, setMenuItems] = useState<any[]>([])

    const editAccess = hasProjectAccess(PRM_CC_REVIEW, EDIT)
    const deleteAccess = hasProjectAccess(PRM_CC_REVIEW, DELETE)

    const hideMenu = () => {
        dispatch(setCcReviewReviewPopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const open = (
        <PopupMenuItem
            key="open"
            onClick={() => {
                if (!activeItem) return
                const revision = revisionActiveList[activeItem.id]
                if (!revision) return

                OpenAnswer(baseRoute, REVIEW, activeFile.id, activeVersion.id, activeItem.id, revision.id, dispatch)
            }}
        >
            {lang.open}
        </PopupMenuItem>
    )
    const edit = (
        <PopupMenuItem
            key="edit"
            onClick={() => {
                if (!activeItem) return
                const revision = revisionActiveList[activeItem.id]
                if (!revision) return

                OpenEdit(baseRoute, REVIEW, activeFile.id, activeVersion.id, activeItem.id, revision.id, dispatch)
            }}
        >
            {lang.edit}
        </PopupMenuItem>
    )
    const remove = (
        <PopupMenuItem
            key="delete"
            onClick={() => dispatch(setCcReviewReviewShowConfirmDelete(true))}
        >
            {lang.delete}
        </PopupMenuItem>
    )

    useEffect(() => {
        if (!activeItem) return

        const menu: any[] = []
        menu.push(open)

        if (editAccess || (activeItem.creator === userData.userId)) menu.push(edit)
        if (deleteAccess || (activeItem.creator === userData.userId)) menu.push(remove)

        setMenuItems(menu)
    }, [activeItem])


    if (!menuItems.length) return null
    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {menuItems}
        </PopupMenu>
    )
}

export default Menu
